export default __webpack_public_path__ + "static/grouped-bar-c7468ad1e814d6ff4075e4e70316545f.png";